import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { deleteUser } from "../../../redux/ducks/user";

const DeleteUser = props => {
    const [show, hide, renderModal] = useModal();
    const [d_deleteUser, status, error, event] = useStatusThunk(deleteUser);

    event.onSuccess = () => hide();

    return (
        <React.Fragment>
            <button className={"button button--danger " + props.className} onClick={show}>Delete User</button>

            {renderModal(
                <React.Fragment>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--danger" onClick={() => { d_deleteUser({ userID: props.userID}) }}>Delete User</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default DeleteUser;